/**
 * Visually-hidden skip link that becomes visible on focus. Lets keyboard
 * users jump past the header/nav directly to the page's <main> landmark.
 * Mounted globally so every route gets it; relies on each page rendering
 * a <main id="main"> wrapper.
 */
export const SkipToContent = () => (
  <a
    href="#main"
    className="sr-only focus:not-sr-only focus:fixed focus:left-3 focus:top-3 focus:z-[100] focus:rounded-md focus:bg-primary focus:px-4 focus:py-2 focus:text-sm focus:font-medium focus:text-primary-foreground focus:shadow-soft focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2"
  >
    Skip to main content
  </a>
);
